import { Box, Skeleton, Stack } from "@mui/material";

export const RouteLoadingFallback = () => (
  <Box height="100vh" display="flex" flexDirection="column" bgcolor="background.default">
    <Skeleton variant="rectangular" height={64} />
    <Stack flex={1} p={3} spacing={2}>
      <Skeleton variant="rounded" height={48} />
      <Skeleton variant="rounded" height={72} />
      <Skeleton variant="rounded" height={72} />
      <Skeleton variant="rounded" height={72} />
      <Skeleton variant="rounded" height={72} />
    </Stack>
  </Box>
);
